// Configurateur — volets "Details de votre tamis" / "Esthetique"
// repliables EN MOBILE UNIQUEMENT (brief "reduire la hauteur du
// configurateur mobile", 2026-09-04). Meme pattern eprouve que
// assets/home-timeline.js : un vrai <details>/<summary> natif, force
// reellement ouvert ([open]) en desktop — un display:block !important
// seul s'est deja revele insuffisant sur certains navigateurs pour le
// contenu replie d'un <details> ferme (voir l'historique de
// sections/home-history-timeline.liquid). Desktop : AUCUN changement
// visuel, le <summary> est en plus masque en CSS (display:none) — son
// etat "open" est donc sans consequence visible, seul le contenu compte.
//
// Contrairement a la timeline, pas d'exclusivite "un seul ouvert a la
// fois" : les 2 volets (Performance et Esthetique) sont independants,
// aucune coordination necessaire entre eux.
//
// 2026-09-04 (ajout) : le CTA "Configurer ma raquette" du bloc juste avant
// (sections/home-customized.liquid, [data-configurateur-open-cta]) deplie
// EN PLUS les 2 volets a son clic, mobile uniquement — l'ancrage vers
// #configurateur lui-meme reste le comportement natif du navigateur,
// inchange.
(function () {
  var root = document.querySelector('[data-configurateur]');
  if (!root) return;
  var foldEls = root.querySelectorAll('[data-config-fold]');
  if (!foldEls.length) return;

  var mql = window.matchMedia('(min-width: 901px)');

  function forceOpenDesktop() {
    foldEls.forEach(function (el) { el.open = true; });
  }

  function restoreMobileDefault() {
    // Redevenu mobile (redimensionnement navigateur) : retour a l'etat
    // initial SSR — les 2 volets fermes.
    foldEls.forEach(function (el) { el.open = false; });
  }

  if (mql.matches) forceOpenDesktop();

  // Franchissement du breakpoint apres coup (redimensionnement de la
  // fenetre, rotation d'ecran) : garde le comportement coherent avec la
  // taille actuelle sans recharger la page.
  var onBreakpointChange = function (e) {
    if (e.matches) {
      forceOpenDesktop();
    } else {
      restoreMobileDefault();
    }
  };
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', onBreakpointChange);
  } else if (typeof mql.addListener === 'function') {
    // Safari < 14.
    mql.addListener(onBreakpointChange);
  }

  // 2026-09-04 (ajout) : le CTA "Configurer ma raquette" du bloc juste
  // avant (sections/home-customized.liquid, data-configurateur-open-cta)
  // pointe deja vers #configurateur (ancrage natif du navigateur, rien a
  // changer la-dessus) — on deplie EN PLUS les 2 volets au clic, mais
  // mobile uniquement : en desktop ils sont deja ouverts en permanence
  // (forceOpenDesktop ci-dessus), rien a faire de plus.
  var openCta = document.querySelector('[data-configurateur-open-cta]');
  if (openCta) {
    openCta.addEventListener('click', function () {
      if (mql.matches) return;
      foldEls.forEach(function (el) { el.open = true; });
    });
  }
})();
